import { useMutation } from 'react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api/src/common/queryFunction';

import { UseBulkUpdateRealTimePricingRequestBody } from './types';

export const useBulkUpdateRealTimePricing: MutationFunction<
  any,
  UseBulkUpdateRealTimePricingRequestBody
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  return useMutation(
    ({ ...body }) =>
      request('/quotes/real_time_pricing_plans/bulk_update', {
        query,
        init: {
          method: 'POST',
          body,
        },
      }),
    {
      mutationKey: ['direct-pricing'],
      ...queryOptions,
    },
  );
};
